import {
  __async
} from "./chunk-WNQUEZJF.mjs";

// src/utils/wait-for-templated-pathname-to-be-ready/wait-for-templated-pathname-to-be-ready.ts
import { State } from "@youversion/analytics-core";
function waitForTemplatedPathnameToBeReady(timeoutMs = 5e3) {
  return __async(this, null, function* () {
    var _a, _b;
    const startTime = performance.now();
    while (performance.now() - startTime < timeoutMs) {
      if (typeof window !== "undefined" && ((_a = window.yvaDatastore) == null ? void 0 : _a.state) && State.get("templatedPathname")) {
        return true;
      }
      yield new Promise((resolve) => setTimeout(resolve, 250));
    }
    if ((_b = window == null ? void 0 : window.yvaDatastore) == null ? void 0 : _b.config.debug) {
      console.error("Timed out waiting for templatedPathname to be ready.");
    }
    return false;
  });
}

export {
  waitForTemplatedPathnameToBeReady
};
